import { TextWithCopy } from '@h2oai/ui-kit';
import React from 'react';

export type UuidTruncatedProps = {
  uuid: string;
};

export const hideTextWithCopyTextStyles = {
  body: {
    backgroundColor: 'transparent',
    borderRadius: 'none',
    button: {
      color: 'inherit',
      i: {
        color: 'inherit',
      },
      left: 0,
    },
    color: 'inherit',
    padding: 0,
  },
  header: {
    paddingRight: 4,
  },
  contents: {
    display: 'none',
  },
};

export const UuidTruncated = React.memo(function UuidTruncated(props: UuidTruncatedProps) {
  const { uuid } = props;
  const tooltipId = uuid; // it is unique and string :)
  return (
    <>
      {uuid.slice(0, 6)}&hellip;{uuid.slice(-6)}{' '}
      <TextWithCopy id={tooltipId} text={uuid} styles={hideTextWithCopyTextStyles} />
    </>
  );
});
